import { Async } from '@client/new/helpers/types';
import { BundleStatus, useGetOtpProductsQuery } from 'generated/graphql';

type OtpProducts = ProductOption[];

export const useOTPProducts = (
  creatorId: number | 'skip' | null,
): Async<OtpProducts> => {
  const res = useGetOtpProductsQuery({
    variables: {
      creatorId: creatorId === 'skip' || creatorId === null ? 0 : creatorId,
    },
    skip: creatorId === null || creatorId === 'skip',
    fetchPolicy: 'no-cache',
  });
  if (creatorId === 'skip') return { type: 'fetched', value: [] };

  if (res.loading) {
    return {
      type: 'fetching',
    };
  }

  if (res.error) {
    return {
      type: 'fetch-error',
      value: 'could not fetch data',
    };
  }

  return {
    type: 'fetched',
    value: toOtpProductsOptions(res.data as RawOTPProducts),
  };
};

type RawOTPProducts = {
  creator: {
    customURL: string;
  };
  collections: Array<{
    id: number;
    name: string;
  }>;
  bundle: Array<{
    id: number;
    title: string;
    landingPageUrl: string;
    status: BundleStatus;
  }>;
};

export type ProductOption = {
  id: number;
  name: string;
  label: string;
  value: number;
  type: 'PROGRAM' | 'OFFER';
  url: string;
};

const toOtpProductsOptions = (data?: RawOTPProducts): Array<ProductOption> => {
  const programs = (data?.collections || []).map((o) => ({
    id: o.id,
    name: o.name,
    label: o.name,
    value: o.id,
    type: 'PROGRAM' as ProductOption['type'],
    url: data?.creator.customURL || '',
  }));
  const offers = (data?.bundle || [])
    .filter((o) => o.status === BundleStatus.Published)
    .map((o) => ({
      id: o.id,
      name: o.title,
      label: o.title,
      value: o.id,
      type: 'OFFER' as ProductOption['type'],
      url: o?.landingPageUrl || '',
    }));
  return [...offers, ...programs];
};
